module.exports = __webpack_public_path__ + "img/loyalty.175f7393.svg";